import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'spark' | 'sage';
}

export function Badge({ children, variant = 'default' }: BadgeProps) {
  const variantClasses = {
    spark: 'bg-spark-s text-spark',
    sage: 'bg-sage-s text-sage',
    default: 'bg-canvas-2 text-ink-3'
  };

  return (
    <span className={`
      ${variantClasses[variant]}
      text-[9.5px] uppercase font-semibold tracking-wider
      px-1.5 py-0.5 rounded
      inline-flex items-center
    `}>
      {children}
    </span>
  );
}